<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/gelanda/maintain/execute/item/page" getKey="rows" :columns="columns" @afterGet="afterGet">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('mujubaoyangdanhao')">
						<el-input disabled v-model="$attrs.item.no"></el-input>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('mujubianhao/mingcheng')">
						<yi_cross_select disabled multiple :selectTitle="'no,name'" :component="'web_base_mould_list'" :ids.sync="$attrs.item.mouldId">
						</yi_cross_select>
					</el-form-item>
					<el-form-item class="noborder" :label="$t('baoyangleixing')">
						<el-select disabled v-model="$attrs.item.type">
							<el-option :label="$t('shoucibaoyang')" :value="0"></el-option>
							<el-option :label="$t('dingqibaoyang')" :value="1"></el-option>
							<el-option :label="$t('chanqianbaoyang')" :value="2"></el-option>
							<el-option :label="$t('chanhoubaoyang')" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="!isStatus" :label="$t('baoyangpingjia')">
						<el-input @input="change($event)" maxlength="400" v-model="remark" :autosize="{ minRows: 1, maxRows: 4 }">
						</el-input>
					</el-form-item>
					<el-form-item v-if="isStatus" class="noborder" :label="$t('baoyangpingjia')">
						<el-input disabled maxlength="400" v-model="remark" :autosize="{ minRows: 1, maxRows: 4 }">
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button v-if="!isStatus" size="mini" @click="beforeAdd" :loading="saveLoading" type="primary">
							{{ $t('baocun') }}
						</el-button>
					</el-form-item>
					<yi_curd_expand_button></yi_curd_expand_button>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button size="mini" @click="yt.editObj.maintainId = $attrs.item.id; yt.editObj.status = 1; yt.req('POST', '/custom/gelanda/maintain/execute/item/beginAll', null, refresh)" type="primary" v-if="!isAllStarted" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具保养执行-一键开始' } }">
							{{ $t('yijiankaishi') }}
						</el-button>
						<el-button size="mini" @click="yt.editObj.maintainId = $attrs.item.id; yt.editObj.status = 2; yt.req('POST', '/custom/gelanda/maintain/execute/item/finishAll', null, refresh)" type="primary" v-if="!isAllFinish" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具保养执行-一键完成' } }">
							{{ $t('yijianwancheng') }}
						</el-button>
            <el-button size="mini" @click="yt.editObj.maintainId = $attrs.item.id; yt.showEditDialog('genghuanxiangjian', null, 'w1');getInsetCode();" type="primary" v-if="!isStatus" >
              {{ $t('genghuanxiangjian') }}
            </el-button>
					</el-col>
					<el-col :span="0.1" v-if="$attrs.item.status == 0 || $attrs.item.status == 1">
						<yi_upload v-if="utils.checkPower('web_maintain_insertImg')" style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="imgInfoIds" :limit="5" @afterUpload="afterUpload" @afterRemove="afterRemove">
							<div slot="limitMsg">
								<span style="margin-left: 12px;font-size: 14px;color: #909399;">
									{{ $t('zuiduoshangchuan') }}
								</span>
								<span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
									<span>5</span>
									<span style="color: #909399;font-size: 14px;font-weight: normal;">
										{{ $t('zizhichitupian') }}
									</span>
								</span>
							</div>
						</yi_upload>
					</el-col>
				</el-row>


			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button v-if="scope.row.status == 0" type="text" @click="startItem(scope.row)" :loading="scope.row.startItemLoading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具保养执行-开始保养' } }">
							{{ $t('kaishibaoyang') }}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="scope.row.status == 1" type="text" @click="finishItem(scope.row)" :loading="scope.row.finishItemLoading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '模具保养执行-完成保养' } }">
							{{ $t('wanchengbaoyang') }}
						</el-button>
					</el-col>
				</el-row>
			</template>
      <template #baoyangbeizhu="scope">
        <div>
          <span v-show="scope.row.status != 1">{{ scope.row.maintainRemark }}</span>
          <el-input v-show="scope.row.status == 1" size="small" v-model="scope.row.maintainRemark"></el-input>
        </div>
      </template>
		</yi_curd_table>

    <!-- 弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 更换镶件表单 -->
      <template v-if="yt.editObj.action == 'genghuanxiangjian'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('dangqianxiangjianbianmamingcheng')" required>
            <el-input disabled v-model="currentCodeAndName"></el-input>
          </el-form-item>
          <el-form-item  :label="$t('genghuanxiangjianbianma')" required>
            <el-select @change="$forceUpdate()" filterable :clearable="true" v-model="yt.editObj.currentInsertId">
              <el-option v-for="(item, index) in codeAndName" :key="index" :label="item.codeAndName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="saveInset()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_mold_management_maintenance_execution_item',
	data() {
		return {
			imgInfoIds: this.$attrs.item.imgInfoIds,
			isUploadFinish: true,
			saveLoading: false,
			remark: '',
      codeAndName:'',
      currentCodeAndName:'',
      moldId: '',
			columns: [{
				label: 'baoyangneirong',
				prop: 'content',
				width: 150
			}, {
				label: 'zhuyishixiang',
				prop: 'carefully',
				width: 150
			}, {
				label: 'beizhu',
				prop: 'remark',
			}, {
				label: 'zhuangtai',
				type: 'tag',
				prop: 'status',
				tags: {
					0: {
						color: '#F56C6C',
						text: this.$t('weibaoyang')
					},
					1: {
						color: '#E6A23C',
						text: this.$t('baoyangzhong')
					},
					2: {
						color: '#67C23A',
						text: this.$t('yiwancheng')
					}
				},
			},
      {
        label: 'caozuoren',
        prop: 'operator.nickname',
        width: 150
      },
      {
        label: 'baoyangbeizhu',
        prop: 'maintainRemark',
        type: 'slot',
        width: 200
      },
      {
				label: 'caozuo',
				type: 'slot',
				width: 150,
				fixed: 'right'
			}]
		};
	},
	computed: {
		isAllStarted() {
      if (this.yt.list) {
        for (var i = 0; i < this.yt.list.length; i++) {
          if (this.yt.list[i].status == "0") {
            return false
          }
        }
        return true
      }
		},
		isAllFinish() {
      if (this.yt.list) {
        for (var i = 0; i < this.yt.list.length; i++) {
          if (this.yt.list[i].status == "1") {
            return false
          }
        }
        return true
      }
		},
		isStatus() {
      if (this.yt.list) {
        for (var i = 0; i < this.yt.list.length; i++) {
          if (this.yt.list[i].status == 1 || this.yt.list[i].status == 0) {
            return false
          }
        }
        return true
      }
		},
	},
	created() {

		setTimeout(() => {
			let file = this.$attrs.item.imgInfoIds
			this.imgInfoIds = file
			this.remark = this.$attrs.item.remark
			this.yt.conditions = {
				maintainId: this.$attrs.item.id,
			}
      this.moldId = this.$attrs.item.mouldId;
			this.yt.get(1);
		}, 300)

	},
	methods: {
    afterGet(){
      for (let i = 0; i < this.yt.list.length; i++) {
        if(this.yt.list[i].status == '1') {
          this.$set(this.yt.list[i], 'maintainRemark', this.yt.list[i].maintainRemark || '');
        }
      }
    },
    saveInset() {
      if(this.yt.editObj.currentInsertId == undefined || this.yt.editObj.currentInsertId == ''){
        this.$message.error(this.$t('xuanzexiangjian'));
        return
      }
      this.saveLoading = true
      this.http.post('/web/mold/insert/change/record/save', {
        moldId: this.moldId,
        currentInsertId: this.yt.editObj.currentInsertId,
      }).then(res => {
        this.$message.success(this.$t(res.msg))
        this.yt.isShowEditDialog = false
      }).catch(error => {
        this.$message.error(this.$t(error))
      }).finally(() => {
        this.saveLoading = false
      })
    },
    getInsetCode() {
      //获取当前模具信息
      this.http.get('/web/basic/mould/get?id='+this.moldId).then(res=>{
        console.log('mold/info',res)
        let currentMoldInsertId = res.data.currentMoldInsertId;
        if(currentMoldInsertId == undefined || currentMoldInsertId == ''){
          return
        }
        this.http.get('/web/basic/mould/mold/insert/get?id='+currentMoldInsertId).then(res=>{
          this.currentCodeAndName = res.data.code + '/' + res.data.name
        })
      })
      //获取镶件列表
      this.http.get('/web/basic/mould/mold/insert/list?mouldId='+this.moldId).then(res=>{
        for(let i=0;i<res.data.length;i++){
          res.data[i].codeAndName = res.data[i].code + '/' + res.data[i].name
        }
        this.codeAndName = res.data
      })
    },
		// 文件上传之后调用
		afterUpload() {
			setTimeout(() => {
				this.http
					.post('/custom/gelanda/maintain/insertImg', {
						id: this.$attrs.item.id,
						imgInfoIds: this.imgInfoIds
					})
					.then(res => {
						this.$message.success(this.$t(res.msg));
					})
					.catch(err => {
						this.$message.error(this.$t(err));
					}).finally(() => {

					});
			}, 1000);
		},
		// 文件移除之后调用
		afterRemove() {
			console.log('afterRemove imageIds', this.imageIds);
			// 更新图片id
			this.http
				.post('/custom/gelanda/maintain/deleteImg', {
					id: this.$attrs.item.id,
					imgInfoIds: this.imgInfoIds
				})
				.then(res => {
					this.$message.success(this.$t(res.msg));
				})
				.catch(err => {
					this.$message.error(this.$t(err));
				});
		},
		refresh() {
			this.yt.get(1);
			this.utils.event_hub.$emit('MOLD_MAINTENANCE_REFRESH');
		},
		addComment() {
			this.$attrs.item.remark = this.remark;
			this.yt.get(1);
			this.utils.event_hub.$emit('MOLD_MAINTENANCE_REFRESH');
		},
		beforeAdd() {

			this.saveLoading = true
			this.http.post('/custom/gelanda/maintain/addRemark', {
				id: this.$attrs.item.id,
				remark: this.remark,
			}).then(res => {
				this.addComment()
				this.$message.success(this.$t(res.msg))
			}).catch(error => {
				this.$message.error(this.$t(error))
			}).finally(() => {
				this.saveLoading = false
			})
		},
		startItem(row) {
			this.$set(row, 'startItemLoading', true)
			this.statusItem = row.status
			this.http.post('/custom/gelanda/maintain/execute/item/begin', {
				id: row.id,
				status: 1
			}).then(res => {
				this.refresh()
				this.$message.success(this.$t(res.msg))
				this.yt.get(1);
			}).catch(error => {
				this.$message.error(this.$t(error))
			}).finally(() => {
				this.$set(row, 'startItemLoading', false)
			})
		},
		finishItem(row) {
			this.$set(row, "finishItemLoading", true)
      let item = this.utils.copy(row);
      item.status = 2;
			this.http.post('/custom/gelanda/maintain/execute/item/finish',item).then(res => {
				this.refresh()
				this.$message.success(this.$t(res.msg))
				this.yt.get(1);
			}).catch(error => {
				this.$message.error(this.$t(error))
			}).finally(() => {
				this.$set(row, "finishItemLoading", false)
			})
		},
		// 重置
		clear() {
			this.yt.conditions = {
				pageNum: 1,
				pageSize: 10
			}
			this.yt.get(1)
		},
	}
};
</script>
